import {FETCH_INTERNSHIP_REQUEST, FETCH_INTERNSHIP_ERROR, FETCH_INTERNSHIP_SUCCES} from '../constants/Internship'

const initialState = {
  item: {},
  hasErrored: false,
  isLoading: false
}

export default function internship(state = initialState, action) {
  switch (action.type) {
      case FETCH_INTERNSHIP_REQUEST:
        return {...state, isLoading: true};
      case FETCH_INTERNSHIP_SUCCES:
        return {...state, item: action.payload, isLoading: false};
      case FETCH_INTERNSHIP_ERROR:
        return {...state, hasErrored: true, isLoading: false};
      default:
          return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/internship.js